var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_4220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.003 15.75C13.1843 15.75 14.1875 15.3365 15.0125 14.5096C15.8375 13.6826 16.25 12.6784 16.25 11.497C16.25 10.3157 15.8365 9.3125 15.0096 8.4875C14.1826 7.6625 13.1784 7.25 11.9971 7.25C10.8157 7.25 9.8125 7.66348 8.9875 8.49045C8.1625 9.3174 7.75 10.3216 7.75 11.503C7.75 12.6843 8.16348 13.6875 8.99045 14.5125C9.8174 15.3375 10.8216 15.75 12.003 15.75ZM11.9941 14.3C11.2147 14.3 10.5542 14.0272 10.0125 13.4816C9.47083 12.936 9.2 12.2735 9.2 11.4941C9.2 10.7147 9.47279 10.0542 10.0184 9.5125C10.564 8.97083 11.2265 8.7 12.0059 8.7C12.7853 8.7 13.4458 8.97279 13.9875 9.51837C14.5292 10.064 14.8 10.7265 14.8 11.5059C14.8 12.2853 14.5272 12.9458 13.9816 13.4875C13.436 14.0292 12.7735 14.3 11.9941 14.3ZM12 19C9.56667 19 7.36667 18.3083 5.4 16.925C3.43333 15.5417 1.96667 13.7333 1 11.5C1.96667 9.26667 3.43333 7.45833 5.4 6.075C7.36667 4.69167 9.56667 4 12 4C14.4333 4 16.6333 4.69167 18.6 6.075C20.5667 7.45833 22.0333 9.26667 23 11.5C22.0333 13.7333 20.5667 15.5417 18.6 16.925C16.6333 18.3083 14.4333 19 12 19ZM11.9958 17.5C14.0153 17.5 15.8708 16.9542 17.5625 15.8625C19.2542 14.7708 20.5417 13.3167 21.425 11.5C20.5417 9.68333 19.2556 8.22917 17.5667 7.1375C15.8779 6.04583 14.0237 5.5 12.0042 5.5C9.98474 5.5 8.12917 6.04583 6.4375 7.1375C4.74583 8.22917 3.45 9.68333 2.55 11.5C3.45 13.3167 4.74442 14.7708 6.43327 15.8625C8.12214 16.9542 9.97631 17.5 11.9958 17.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_4220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOn);
export default __webpack_public_path__ + "static/media/icon-eye-on.cb69659f87c6a15c73642fb177082600.svg";
export { ForwardRef as ReactComponent };